import React from 'react';
import { Tooltip } from 'reactstrap';
import classNames from 'classnames';
import {ReactComponent as Documents} from '../images/svg_icons/documents.svg'

class DocumentsButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            printPreviewUrl: null,
            documents_tooltipOpen: false
        }
    }

    toggle = (key) => {
        this.setState({ [key]: !this.state[key] })
    }

    handleClick = () => {
        this.props.publicPortal ? this.props.toggleLoginModal() : this.props.onDocumentsClicked()
    }
     
    render() {
        const { listingId, count, isOpen } = this.props;
        return <button type="button" className={classNames('documents-button', { open: isOpen })} onClick={() => this.handleClick()}>
            <Documents id={'documents_' + listingId} /> <span className="documents-count">{count}</span>
            <Tooltip delay={{ show: 0, hide: 0 }} isOpen={this.state.documents_tooltipOpen} toggle={() => !this.props.publicPortal ? this.toggle('documents_tooltipOpen') : null} placement="top"
                target={'documents_' + listingId} >
                Documents
            </Tooltip>
        </button>
    }
}

  export default DocumentsButton 